<template>
  <div class="massage">
    <app-header :background-name="'wallpaper4.jpg'">
      <h1>Stéphanie Lefebvre</h1>
      <h2>Massage des 5 continents</h2>
    </app-header>

    <div class="content">
      <article>
        <div class="bloc">
          <h1>Massage des 5 continents</h1>

          <p>
            Le <b>Massage des 5 Continents</b> est un merveilleux soin riche de différentes techniques de massage (Lomi Lomi,
            Californien, Suédois, Ayurvédique, Tuina) associées à l'énergie du Reiki, du LaHoChi ou encore du magnétisme
            ainsi qu'aux huiles essentielles.
          </p>
          <p>
            Cette méthode de massage reliée à l'énergie de guérison et à l'énergie universelle nous permet de faire
            remonter doucement le long du corps et de la colonne vertébrale la force vitale, Khundalini, et d'en
            diffuser une grande quantité dans le coeur.
          </p>

          <p>Ce massage est un <b>soin complet</b> permettant d'enclencher les processus d'auto-guérison en déchargeant le
            corps des mémoires émotionnelles encombrantes et des toxines.</p>
        </div>
        <div class="bloc">
          <p>
            Il permet de laisser se dérouler un cheminement interne réparateur, ouvrant la mémoire cellulaire du corps,
            nettoyant peu à peu les charges émotionnelles, les anciennes blessures, les peurs et les schémas qui nous
            entravent et laissant l'énergie de plaisir, de vie et d'Amour circuler librement et harmonieusement en nous.
          </p>

          <p>
            Ce merveilleux voyage intérieur apporte un <b>lâcher prise physique et mental</b> et permet, petit à petit, de
            retrouver une grande confiance et une nouvelle vitalité, de retrouver l'estime de soi, la joie de vivre
            ainsi qu'un profond sentiment de paix.
          </p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header'

export default {
  name: 'Massage',
  components: { AppHeader }
}
</script>

<style lang="scss" scoped>
.massage {
  display: flex;
  flex-direction: column;
  flex: 1;

  .content {
    position: relative;
    text-align: center;
    background-color: #f1fae7;
    align-items: center;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media screen and (max-width: 680px) {
      overflow: auto;
    }

    article {
      @include custom-article();

      img {
        position: absolute;
        z-index: 0;
        opacity: .5;

        &.left {
          bottom: -2vw;
          left: -1vw;
        }

        &.right {
          top: -1vw;
          right: -1vw;
        }
      }
    }
  }
}
</style>
